import { cookie } from '@pdrj/pmi-iqos-shared-react'

export default class IqosphereStarterPack {
  constructor(api) {
    this.api = api
  }

  getStarterPackStatus = async campaign => {
    return await this.api.get(
      '/iqosphere/starterpackage/status?campaign=' + campaign,
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        mock: this.api.getMock('getStarterPackStatus')
      }
    )
  }

  submitStarterPackTask = async (campaign, code) => {
    return await this.api.post('/iqosphere/starterpackage/submit?rpc=true', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      useProxy: true,
      withCredentials: true,
      data: {
        campaign,
        code
      },
      mock: this.api.getMock('submitStarterPackTask')
    })
  }
}
